import React from 'react';


export default class Games extends React.Component {

  render() {
    let {games} = this.props;

    return (
      <div className="Games">
        {
          games.map(g => (
            <div key={g.kiosk_game_id} onClick={
              () => this.props.onSelectGame(g.kiosk_game_id)
            }>
              <img src={g.icon} alt="" />
            </div>
          ))
        }
      </div>
    );
  }
}
